export const FETCH_CREDITNOTESDETAILS_INIT_ACTION =
  "FETCH_CREDITNOTESDETAILS_INIT_ACTION";
export const FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION =
  FETCH_CREDITNOTESDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_CREDITNOTESDETAILS_FAIL_ACTION =
  FETCH_CREDITNOTESDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_CREDITNOTESSEARCH_INIT_ACTION =
  "FETCH_CREDITNOTESSEARCH_INIT_ACTION";
export const FETCH_CREDITNOTESSEARCH_SUCCESS_ACTION =
  FETCH_CREDITNOTESSEARCH_INIT_ACTION + "_SUCCESS";
export const FETCH_CREDITNOTESSEARCH_FAIL_ACTION =
  FETCH_CREDITNOTESSEARCH_INIT_ACTION + "_ERROR";

export function CreditNote() {
  return {
    type: FETCH_CREDITNOTESDETAILS_INIT_ACTION
  };
}
export function CreditNotesSlectedPage(value) {
  return {
    type: FETCH_CREDITNOTESDETAILS_INIT_ACTION,
    value: value
  };
}
export function CreditNoteSearch(value) {
  return {
    type: FETCH_CREDITNOTESSEARCH_INIT_ACTION,
    value: value
  };
}
export function CreditNoteSearchSelectedPage(value) {
  return {
    type: FETCH_CREDITNOTESSEARCH_INIT_ACTION,
    value: value
  };
}
